/**
 * Short calendar date ("Sep 29") in the viewer's local time zone.
 *
 * @module lib/formatShortDate
 */
const SHORT_DATE = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

/** " (from Sep 29)" for a carried-forward diagnosis section title, or '' when not a repeat. */
export function repeatedFromSuffix(repeatOf: { runCreatedAt: string } | undefined): string {
  return repeatOf ? ` (from ${formatShortDate(repeatOf.runCreatedAt)})` : '';
}

/** Returns '' for an unparseable value. */
export function formatShortDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return SHORT_DATE.format(date);
}
